import { render, staticRenderFns } from "./DeviationTypes.vue?vue&type=template&id=456891a0&scoped=true&"
import script from "./DeviationTypes.vue?vue&type=script&lang=js&"
export * from "./DeviationTypes.vue?vue&type=script&lang=js&"
import style0 from "./DeviationTypes.vue?vue&type=style&index=0&id=456891a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456891a0",
  null
  
)

/* custom blocks */
import block0 from "./DeviationTypes.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports